import { Template, Group, Miniature } from '../../../models';

export function createGroupMiniatures(templates: Template[], groups: Group[]): Miniature[] {
    let miniatures = [];
    if (templates) {
        miniatures = templates.map((t, i) => {

            const deleteUsage = groups.filter(g => g.templateGuid === t.guid);
            const isUsed = deleteUsage.length > 0;

            return {
                group: 'templates',
                create: () => {
                },
                highlights: [t.shortComment],
                icon: 'fa-clipboard',
                sortingOrder: i + 2,
                title: t.name,
                type: `template${t.guid}`,
                delete: true,
                deleteClass: isUsed ? 'disabled' : '',
                deleteModal: isUsed ? '#contextualCannotDeleteModal' : '#contextualDeleteModal',
                deleteUsage: deleteUsage,
                guid: t.guid // add a guid to allow delete
            };
        });
    }

    miniatures.push({
        group: 'templates',
        create: () => {
        },
        highlights: ['An empty group'],
        icon: 'fa-tree',
        sortingOrder: 0,
        title: 'Empty group',
        type: 'group'
    });

    miniatures.push({
        group: 'templates',
        create: () => {
        },
        highlights: ['A group managing redundant tags'],
        icon: 'fa-sitemap fa-rotate-90',
        sortingOrder: 1,
        title: 'Redundancy group',
        type: 'redundancyGroup'
    });
    return miniatures;
}